import create from 'zustand';
import createStoreSelectors from './utils/createStoreSelector';

const useStore = create((set) => ({
  isPaymentNudge: true,
  setPaymentNudge: (value) => {
    set((state) => ({
      ...state,
      isPaymentNudge: value
    }));
  }
}));

const usePaymentNudgeStore = createStoreSelectors(useStore);

export default usePaymentNudgeStore;
